import React, { useEffect, useRef } from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import { getSnackBarProps } from '../../../store/global/selectors';
import { handleSnackBar } from '../../../store/global/actions';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
  },
  snackBar: {
    zIndex: 1502,
    marginTop: 55
  }
}));

export default function Snackbars() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const timerRef = useRef(null);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(handleSnackBar({}, true));
  };



  const { message, autoHideDuration, open, severity, ...rest } = useSelector(getSnackBarProps);

  useEffect(() => {
    clearTimeout(timerRef.current);
    if (open) {
      timerRef.current = setTimeout(handleClose, autoHideDuration || 6000);
    }
    return () => clearTimeout(timerRef.current);
  }, [message, open]);

  return (
    <div className={classes.root}>
      <Snackbar
        {...rest}
        open={open}
        onClose={handleClose}
        className={classes.snackBar}
        autoHideDuration={autoHideDuration}
        key={message}
      >
        {open && (
          <Alert onClose={handleClose} severity={severity}>
            {message}
          </Alert>
        )}
      </Snackbar>
    </div>
  );
}

